import { FaIcon } from '@fe-learner-common';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { ReactNode } from 'react';

type ResourceActionsProps = {
  children: ReactNode;
  hasDescription: boolean;
  onDescriptionClick: (resourceId: string) => void;
  resourceId: string;
  descriptionAriaLabel: string;
};

export const ResourceActions = ({
  resourceId,
  hasDescription,
  onDescriptionClick,
  descriptionAriaLabel,
  children,
}: ResourceActionsProps) => (
  <div className="relative z-10 -mr-1 -mt-1 flex items-center gap-x-2">
    {hasDescription && (
      <button
        type="button"
        className="l-btn l-btn-sm l-btn-tertiary l-icon-btn hover:bg-neutral-50"
        onClick={() => {
          onDescriptionClick(resourceId);
        }}
        aria-label={descriptionAriaLabel}
      >
        <FaIcon width={16} height={16} icon={faInfoCircle} />
      </button>
    )}
    {children}
  </div>
);
